"use client";

import React, { useEffect, useState } from "react";
import { Target } from "lucide-react";
const findings = ["Completion: 2023 — Integration of high-performance materials and sustainable engineering solutions.", "Scale: 50,000 sqm — A landmark mixed-use development designed for high-density urban efficiency.", "Location: Central District — Revitalizing the city's architectural landscape with iconic geometry.", "Sustainability: LEED Gold — Optimized for maximum energy conservation and carbon footprint reduction.", "Status: Operational — Successfully delivered and serving as a benchmark for modern structural design."];
export default function ResearchOverview() {
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="134233" id="project-overview" className="relative overflow-hidden bg-background py-[160px] text-foreground">
      {/* Background Layer */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/architectural_research_bg.png)] bg-cover bg-center bg-no-repeat border-l-[12px] border-accent/20" />
        {/* Subtle overlay to soften the image for light mode */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 to-background/90" />
      </div>

      {/* Decorative Parallax Text */}
      <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center overflow-hidden" aria-hidden="true">
        <span className="font-default text-[20vw] font-black leading-none tracking-tighter text-primary opacity-[0.03] select-none" style={{
        transform: `translateY(${offsetY * 0.1}px)`,
        willChange: "transform"
      }}>
          SPECS
        </span>
      </div>

      {/* Content Container */}
      <div className="container relative z-10 mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24">
          {/* Left Column: Project Title & Description */}
          <div className="flex flex-col justify-center">
            <span className="mb-6 block font-mono text-[14px] font-medium tracking-widest text-accent uppercase">
              Project Overview
            </span>
            <h2 className="font-default text-[48px] font-bold leading-[1.1] tracking-tight text-primary md:text-[64px]">
              Innovative Urban Engineering
            </h2>
          </div>

          {/* Right Column: Technical Specifications Grid */}
          <div className="flex flex-col justify-center">
            <ul className="space-y-8">
              {findings.map((finding, i) => <li key={i} data-index={i} className="flex items-start gap-4 border border-border bg-card p-6 rounded-none shadow-sm transition-transform duration-300 hover:-translate-y-1">
                  <Target strokeWidth={1} className="mt-1 size-6 shrink-0 text-accent" aria-hidden="true" />
                  <p className="font-mono text-[16px] leading-relaxed text-muted-foreground">
                    {finding}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}